<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <fa-icon *ngIf="showIcon" class="prompt-icon text-primary" [icon]="faInfoCircle"></fa-icon>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <textarea
                    style="resize: none; white-space: pre"
                    rows="{{ rows }}"
                    spellcheck="false"
                    type="text"
                    class="form-control"
                    [(ngModel)]="messages"
                    name="messages"
                    readonly
                ></textarea>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="ok()">OK</button>
</div>
